import { CaptionElement } from '@app/common';
import TextWithReferences from '../TextWithReferences/TextWithReferences';

type Properties = {
    data: CaptionElement;
};

const Caption = (props: Properties) => {
    let caption: JSX.Element;
    if (props.data.size !== 2) {
        caption = <h1 className="page-caption"><TextWithReferences text={props.data.text} /></h1>;
    } else {
        caption = <h2 className="page-caption"><TextWithReferences text={props.data.text} /></h2>;
    }

    return ( <>{caption}</> );
};
export default Caption;